/* jshint esversion: 11 */

window.gallerySettings = {
    gallery: {
        selector: '.pswp-gallery',
        itemSelector: '.pswp-gallery__item'
    }
};

// Debug window.landingPageProducts
console.log('Landing Page Products:', {
    products: window.landingPageProducts,
    firstProduct: Object.values(window.landingPageProducts)[0],
    metafields: Object.values(window.landingPageProducts)[0]?.metafields,
    customMetafields: Object.values(window.landingPageProducts)[0]?.metafields?.custom
});

class LandingPageHandler {
    constructor() {
        this.elements = {
            productTypeSelector: document.querySelector('.product-type-selector'),
            addToCartButton: document.querySelector('#AddToCart'),
            addToCartForm: document.querySelector('#AddToCartForm'),
            swatchContainer: document.querySelector('#swatchContainer'),
            sizeSelectorContainer: document.querySelector('#sizeSelectorContainer'),
            heroGallery: document.querySelector('#hero-gallery')  // Add this
        };

        this.state = {
            currentProduct: null,
            selectedColor: null,
            selectedSize: null,
            currentVariant: null,
            globalSelectedColor: null,
            isFirstProductClick: true,
            isInitialLoad: true,
            hasUserClickedProduct: false
        };
        
        this.lightbox = null;  // Add this
        this.initPhotoSwipe();  // Add this
        this.init();
        this.ensureImageDimensions(); // Preload and set image dimensions

        this.pageDetails = {
            title: document.querySelector('#hero-gallery h1')?.textContent,
            price: document.querySelector('#product-price')?.textContent,
            reviews: document.querySelector('.reviews')?.textContent
        };
    }

    ensureImageDimensions() {
        // Preload the full-size image to get actual dimensions
        const heroLink = this.elements.heroGallery?.querySelector('.hero-image-link');
        const heroImg = this.elements.heroGallery?.querySelector('img');
        
        if (!heroLink || !heroImg) return;
        
        // Set dimensions immediately from data attributes if available
        const width = heroLink.dataset.pswpWidth || heroImg.getAttribute('width');
        const height = heroLink.dataset.pswpHeight || heroImg.getAttribute('height');
        
        if (width && height) {
            heroLink.dataset.pswpWidth = width;
            heroLink.dataset.pswpHeight = height;
        }
        
        // Also preload to verify/update dimensions
        const fullSizeUrl = heroLink.href;
        const img = new Image();
        img.onload = () => {
            // Set the actual dimensions of the full-size image
            heroLink.dataset.pswpWidth = img.naturalWidth;
            heroLink.dataset.pswpHeight = img.naturalHeight;
            console.log('Image dimensions set:', img.naturalWidth, 'x', img.naturalHeight);
        };
        img.onerror = () => {
            console.warn('Failed to load image for dimension detection');
        };
        img.src = fullSizeUrl;
    }

    initPhotoSwipe() {
        if (!this.elements.heroGallery) return;
        
        // Prevent multiple simultaneous initializations
        if (this._initializingPhotoSwipe) return;
        this._initializingPhotoSwipe = true;
        
        // Wait for PhotoSwipe to be available
        if (typeof PhotoSwipe === 'undefined' || typeof PhotoSwipeLightbox === 'undefined') {
            this._initializingPhotoSwipe = false;
            setTimeout(() => this.initPhotoSwipe(), 100);
            return;
        }
    
        try {
            // Destroy existing lightbox if it exists
            if (this.lightbox) {
                try {
                    this.lightbox.destroy();
                } catch (e) {
                    // Ignore destroy errors
                }
                this.lightbox = null;
            }
        
            this.lightbox = new PhotoSwipeLightbox({
                gallery: '#hero-gallery',
                children: '.hero-image-link',
                pswpModule: PhotoSwipe,
        
                loop: true,
                padding: { top: 0, bottom: 0, left: 0, right: 0 },
                bgOpacity: 1,
                showHideOpacity: true,
                closeOnVerticalDrag: true,
                closeOnOutsideClick: true,
        
                zoom: {
                    click: true,
                    doubleClick: false,
                    mouseWheel: true,
                    maxRatio: 3
                },
                arrowPrev: true,
                arrowNext: true,
                counter: true,
                arrowKeys: true,
                wheelToZoom: true,
                imageClickAction: 'zoom',
                tapAction: 'zoom',
                scaleMode: 'fit'
            });
            
            // Ensure proper viewport centering when opening
            this.lightbox.on('afterInit', () => {
                if (this.lightbox.pswp) {
                    // Update viewport size
                    this.lightbox.pswp.updateSize();
                }
            });
            
            // Ensure centering after image loads
            this.lightbox.on('loadComplete', (e) => {
                if (this.lightbox.pswp) {
                    // Update size and center
                    this.lightbox.pswp.updateSize();
                    // Reset zoom to fit and center
                    this.lightbox.pswp.zoomTo(1, { x: 0, y: 0 }, 0);
                }
            });
        
            // Simplified itemData filter - let PhotoSwipe handle dimensions automatically
            this.lightbox.addFilter('itemData', (itemData, index) => {
                try {
                    const heroLink = this.elements.heroGallery?.querySelector('.hero-image-link');
                    if (heroLink) {
                        // Use data attributes if available
                        const width = parseInt(heroLink.dataset.pswpWidth);
                        const height = parseInt(heroLink.dataset.pswpHeight);
                        
                        if (width && height && width > 0 && height > 0) {
                            itemData.w = width;
                            itemData.h = height;
                        }
                    }
                } catch (e) {
                    console.warn('Error in itemData filter:', e);
                }
                return itemData;
            });
        
            this.lightbox.init();
        } catch (e) {
            console.error('Error initializing PhotoSwipe:', e);
        } finally {
            this._initializingPhotoSwipe = false;
        }
    }

    updateHeroGallery(imageUrl) {
        if (!this.elements.heroGallery) return;
        
        const heroImg = this.elements.heroGallery.querySelector('img');
        const heroLink = this.elements.heroGallery.querySelector('a');
        if (heroImg && heroLink) {
            // Maintain consistent height to prevent layout shift
            heroImg.style.height = '28vh';
            heroImg.style.maxHeight = '28vh';
            heroImg.style.width = 'auto';
            heroImg.style.objectFit = 'contain';
            heroImg.style.display = 'block';
            heroImg.style.margin = '0 auto';
            
            // Preload image to get dimensions before updating
            const img = new Image();
            img.onload = () => {
                heroImg.src = imageUrl;
                heroLink.href = imageUrl;
                // Update data attributes for PhotoSwipe
                heroLink.dataset.pswpWidth = img.naturalWidth;
                heroLink.dataset.pswpHeight = img.naturalHeight;
                
                // Reinitialize PhotoSwipe to pick up new image
                this.initPhotoSwipe();
            };
            img.onerror = () => {
                // Fallback: update anyway
                heroImg.src = imageUrl;
                heroLink.href = imageUrl;
                this.initPhotoSwipe();
            };
            img.src = imageUrl;
        }
    }

    init() {
        // Initialize product type buttons
        const productButtons = this.elements.productTypeSelector?.querySelectorAll('.product-type-button');
        if (productButtons?.length) {
            productButtons.forEach(button => {
                button.addEventListener('click', () => this.handleProductSelection(button));
            });
            
            // Select first product by default
            this.handleProductSelection(productButtons[0]);
            this.state.isInitialLoad = false;  // Set to false after initial selection
        }

        // Initialize form submission
        this.elements.addToCartForm?.addEventListener('submit', (e) => this.handleAddToCart(e));
    }

    autoSelectInitialVariant() {
        if (!this.state.currentProduct) return;
        
        // Find first available variant
        const firstAvailableVariant = this.state.currentProduct.variants.find(v => v.available);
        
        if (firstAvailableVariant) {
            const color = firstAvailableVariant.option1;
            const size = firstAvailableVariant.option2;
            
            // Update color selection
            this.state.selectedColor = color;
            this.handleColorSelection(color, false, true);  // true flag indicates initial load
            const colorInput = document.querySelector(`input[name="option-0"][value="${color}"]`);
            if (colorInput) {
                colorInput.checked = true;
            }
            
            // Update size selection
            this.state.selectedSize = size;
            this.handleSizeSelection(size);
            const sizeInput = document.querySelector(`input[name="option-1"][value="${size}"]`);
            if (sizeInput) {
                sizeInput.checked = true;
            }
            
            // Update variant
            this.updateVariant();
        }
    }


    

    handleProductSelection(button) {
        console.log('Product Selection State:', {
            isFirstClick: this.state.isFirstProductClick,
            isInitialLoad: this.state.isInitialLoad,
            currentSize: this.state.selectedSize,
            button: button
        });
    
        // Update button states
        this.elements.productTypeSelector
            .querySelectorAll('.product-type-button')
            .forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
    
        // Get product data
        const productId = button.dataset.productId;
        const productData = window.landingPageProducts[productId];
        
        // Store current size before updating product
        const previousSize = this.state.selectedSize;
        
        // Update state with product data
        this.state.currentProduct = {
            ...productData,
            id: productId
        };
        
        // Update main title if user has clicked (not on initial load)
        // Only update if this is NOT the initial load
        if (!this.state.isInitialLoad && productData?.title) {
            const mainTitleElement = document.getElementById('landing-page-main-title');
            if (mainTitleElement) {
                mainTitleElement.textContent = productData.title;
            }
        }
    
        // Show form
        if (this.elements.addToCartForm) {
            this.elements.addToCartForm.style.display = 'block';
        }
    
        // Render variant selectors
        this.renderColorSwatches();
        this.renderSizeOptions();
    
        // Handle selection based on state
        if (this.state.isInitialLoad) {
            this.autoSelectInitialVariant();
            this.state.isInitialLoad = false;
        } else if (this.state.isFirstProductClick) {
            const defaultColor = productData.default_color;
            const previousSize = this.state.selectedSize;  // Store previous size
            
            if (defaultColor) {
                const isDefaultColorAvailable = this.state.currentProduct.variants.some(v => 
                    v.option1 === defaultColor && v.available
                );
                
                if (isDefaultColorAvailable) {
                    // Changed isInitialLoad to false here
                    this.handleColorSelection(defaultColor, false, false);
                    const colorInput = document.querySelector(`input[name="option-0"][value="${defaultColor}"]`);
                    if (colorInput) {
                        colorInput.checked = true;
                    }
                    
                    // Check if previous size is available with new color
                    if (previousSize) {
                        const isSizeAvailable = this.state.currentProduct.variants.some(v => 
                            v.option2 === previousSize && 
                            v.option1 === defaultColor && 
                            v.available
                        );
                        
                        if (isSizeAvailable) {
                            this.state.selectedSize = previousSize;
                            const sizeInput = document.querySelector(`input[name="option-1"][value="${previousSize}"]`);
                            if (sizeInput) {
                                sizeInput.checked = true;
                            }
                            document.getElementById('selected-size-name').textContent = previousSize;
                        } else {
                            // If size not available, select first available size for this color
                            const firstAvailableVariant = this.state.currentProduct.variants.find(v => 
                                v.option1 === defaultColor && v.available
                            );
                            if (firstAvailableVariant) {
                                this.handleSizeSelection(firstAvailableVariant.option2);
                            }
                        }
                    }
                } else {
                    this.autoSelectInitialVariant();
                }
            } else {
                this.autoSelectInitialVariant();
            }
            this.state.isFirstProductClick = false;
        } else {
            // Handle subsequent product clicks
            if (this.state.globalSelectedColor) {
                this.handleColorSelection(this.state.globalSelectedColor);
                const colorInput = document.querySelector(`input[name="option-0"][value="${this.state.globalSelectedColor}"]`);
                if (colorInput) {
                    colorInput.checked = true;
                }
            }
            
            // Always maintain size selection
            if (previousSize) {
                this.state.selectedSize = previousSize;
                const sizeInput = document.querySelector(`input[name="option-1"][value="${previousSize}"]`);
                if (sizeInput) {
                    sizeInput.checked = true;
                    document.getElementById('selected-size-name').textContent = previousSize;
                }
            }
        }
        
        this.updateProductDetails();
        this.updateVariant();
        this.updateAddToCartButton();
        this.updatePrice(); 


    }
    
    renderColorSwatches() {
        if (!this.state.currentProduct) {
            console.log('No current product selected');
            return;
        }
        
        console.log('Current Product:', this.state.currentProduct);
        
        // Create a new container for the swatch
        const swatchContainer = document.createElement('div');
        swatchContainer.className = 'swatch clearfix';
        swatchContainer.setAttribute('data-option-index', '0');
        
        // Get the color options from the current product
        const colorOption = this.state.currentProduct.options_with_values.find(opt => 
            opt.name.toLowerCase() === 'color'
        );
        
        if (!colorOption) {
            console.error('No color option found for product');
            return;
        }
        
        // Create the color name container
        const colorNameRow = document.createElement('div');
        colorNameRow.className = 'row';
        colorNameRow.innerHTML = `
            <div class="col-12 text-left text-lg-center" id="color-name-container" style="font-size: 14px;">
                <b>Color:</b> <span id="selected-color-name">Please select color</span>
            </div>
        `;
        swatchContainer.appendChild(colorNameRow);
        
        // Manual color mapping (same as in swatch-collection.liquid)
        const manualColors = {
            'white': '#F9F9F9',
            'lime-green': '#AAF55F',
            'army-green': '#6F7F28',
            'navy-blue': '#204677',
            'tan': '#E8CAA5',
            'blue': '#005BD3',
            'yellow': '#FFE500',
            'green': '#05AA3D',
            'red': '#F61F1F',
            'orange': '#FF8A00',
            'grey': '#A7A7A7',
            'cream': '#F2ECD3',
            'light-brown': '#C57411',
            'khaki': '#E0B581',
            'charcoal': '#595858',
            'pink': '#FDC7D0',
            'chocolate-brown': '#6A3318',
            'lavender': '#EACDFF',
            'sage-green': '#2B5F31',
            'black': '#000000',
            'baby-blue': '#7DCBF8'
        };
        
        // Create swatches for each color
        colorOption.values.forEach(color => {
            // Check if color is sold out
            const isSoldOut = !this.state.currentProduct.variants.some(v => 
                v.option1 === color && v.available
            );
            
            const colorHandle = color.toLowerCase().replace(/\s+/g, '-');
            const backgroundColor = manualColors[colorHandle] || manualColors[colorHandle.split('-')[0]];
            
            const swatchElement = document.createElement('div');
            swatchElement.className = `swatch-element color ${colorHandle}${isSoldOut ? ' soldout' : ''}`;
            swatchElement.setAttribute('data-value', color);
            
            swatchElement.innerHTML = `
                <input id="swatch-0-${color}" 
                       type="radio" 
                       name="option-0" 
                       value="${color}" />
                <label for="swatch-0-${color}" ${backgroundColor ? `style="background-color: ${backgroundColor};"` : ''}>
                    <div class="crossed-out"></div>
                </label>
            `;
            
            swatchContainer.appendChild(swatchElement);
            
            // Add click handler
            swatchElement.querySelector('input').addEventListener('change', (e) => {
                this.handleColorSelection(color, isSoldOut);
            });
        });
        
        // Update the DOM
        if (this.elements.swatchContainer) {
            this.elements.swatchContainer.innerHTML = '';
            this.elements.swatchContainer.appendChild(swatchContainer);
        }
    }    
    handleColorSelection(color, isSoldOut, isInitialLoad) {
        // Update global color state
        this.state.globalSelectedColor = color;
        this.state.selectedColor = color;
        
        // Update images if not initial load
        if (!isInitialLoad) {
            // Update all product thumbnails
            const productButtons = this.elements.productTypeSelector.querySelectorAll('.product-type-button');
            productButtons.forEach(button => {
                const productId = button.dataset.productId;
                const productData = window.landingPageProducts[productId];
                
                const matchingVariant = productData.variants.find(v => 
                    v.option1 === color && v.available
                );
                
                if (matchingVariant?.featured_image) {
                    const thumbnailImg = button.querySelector('img');
                    if (thumbnailImg) {
                        thumbnailImg.src = matchingVariant.featured_image.src;
                    }
                }
            });

            // Update hero image and reinitialize PhotoSwipe
            const currentVariant = this.state.currentProduct.variants.find(v => 
                v.option1 === color
            );
            
            if (currentVariant?.featured_image) {
                const heroImg = this.elements.heroGallery.querySelector('img');
                const heroLink = this.elements.heroGallery.querySelector('a');
                if (heroImg && heroLink) {
                    // Maintain consistent height to prevent layout shift
                    heroImg.style.height = '28vh';
                    heroImg.style.maxHeight = '28vh';
                    heroImg.style.width = 'auto';
                    heroImg.style.objectFit = 'contain';
                    heroImg.style.display = 'block';
                    heroImg.style.margin = '0 auto';
                    
                    // Preload image to get dimensions
                    const img = new Image();
                    img.onload = () => {
                        heroImg.src = currentVariant.featured_image.src;
                        heroLink.href = currentVariant.featured_image.src;
                        heroLink.dataset.pswpWidth = img.naturalWidth;
                        heroLink.dataset.pswpHeight = img.naturalHeight;
                        
                        // Reinitialize PhotoSwipe with new image
                        this.initPhotoSwipe();
                    };
                    img.onerror = () => {
                        // Fallback: use provided dimensions
                        heroImg.src = currentVariant.featured_image.src;
                        heroLink.href = currentVariant.featured_image.src;
                        heroLink.dataset.pswpWidth = currentVariant.featured_image.width;
                        heroLink.dataset.pswpHeight = currentVariant.featured_image.height;
                        this.initPhotoSwipe();
                    };
                    img.src = currentVariant.featured_image.src;
                }
            }
        }
        // Update color name
        document.getElementById('selected-color-name').textContent = color;
        
        // Get all sizes for this color (available or not)
        const allSizesForColor = this.state.currentProduct.variants
            .filter(v => v.option1 === color)
            .map(v => v.option2);
            
        console.log('Sizes for color:', {
            color,
            allSizes: allSizesForColor,
            availableSizes: this.state.currentProduct.variants
                .filter(v => v.option1 === color && v.available)
                .map(v => v.option2)
        });

        // Only select a new size if there isn't one already selected
        if (!this.state.selectedSize && allSizesForColor.length > 0) {
            // Try to find first available size
            const firstAvailableSize = this.state.currentProduct.variants.find(v => 
                v.option1 === color && v.available
            )?.option2;
            
            // If no available sizes, use first size
            const sizeToSelect = firstAvailableSize || allSizesForColor[0];
            
            this.state.selectedSize = sizeToSelect;
            document.getElementById('selected-size-name').textContent = sizeToSelect;
        }
        
        // Re-render size options with new color's availability
        this.renderSizeOptions();

        this.updateProductDetails();
        
        this.updateVariant();
        this.updateAddToCartButton();
        this.updatePrice();  // Add this
    
    }

    updatePrice() {
        if (!this.state.currentProduct || !this.state.currentVariant) return;
        
        // Update price
        const priceElement = document.getElementById('product-price');
        if (!priceElement) return;
    
        const variant = this.state.currentVariant;
        const price = (variant.price/100).toFixed(2);
        const comparePrice = variant.compare_at_price ? (variant.compare_at_price/100).toFixed(2) : null;
        
        if (comparePrice && comparePrice > price) {
            priceElement.innerHTML = `
                <span class="product-original-price">$${comparePrice}</span>
                <span class="product-sale-price">$${price}</span>
            `;
        } else {
            priceElement.innerHTML = `<span class="product-sale-price">$${price}</span>`;
        }
    
        // Don't update subheader - it's now static "Black Friday Sale!"
    }

        
    initializeColorListeners() {
        const productId = this.state.currentProduct.id;
        const colorInputs = document.querySelectorAll(`input[name="option-${productId}-0"]`);
        
        colorInputs.forEach(input => {
            input.addEventListener('change', (e) => {
                const swatchElement = e.target.closest('.swatch-element');
                const color = swatchElement.dataset.value;
                const isSoldOut = swatchElement.classList.contains('soldout');
                
                // Update color name
                const colorNameElement = document.querySelector(`#selected-color-name-${productId}`);
                if (colorNameElement) {
                    colorNameElement.textContent = color;
                }

                // Update state
                this.state.selectedColor = color;
                this.state.selectedSize = null;
                
                // Update UI
                this.renderSizeOptions();
                this.updateVariantSelection();
                this.updateAddToCartButton();
            });
        });
    }
    validateState() {
        const validationResult = {
            isValid: false,
            activeColor: null,
            currentProduct: this.state.currentProduct,
            variants: []
        };
    
        if (!this.state.currentProduct) {
            console.log('Validation failed: No current product');
            return validationResult;
        }
    
        // Prioritize selectedColor over other options
        let activeColor = this.state.selectedColor;  // Use selected color first
        
        if (!activeColor) {
            // Fall back to other color selection methods
            if (this.state.isInitialLoad) {
                activeColor = this.state.currentProduct.variants.find(v => v.available)?.option1;
            } else if (this.state.isFirstProductClick) {
                activeColor = this.state.currentProduct.default_color || 
                             this.state.currentProduct.variants.find(v => v.available)?.option1;
            } else {
                activeColor = this.state.globalSelectedColor || 
                             this.state.currentProduct.variants.find(v => v.available)?.option1;
            }
        }
    
        if (!activeColor) {
            console.log('Validation failed: No active color determined');
            return validationResult;
        }
    
        // Get variants for the active color
        const variants = this.state.currentProduct.variants.filter(v => 
            v.option1 === activeColor
        );
    
        validationResult.isValid = true;
        validationResult.activeColor = activeColor;
        validationResult.variants = variants;
    
        return validationResult;
    }
    renderSizeOptions() {
        // Validate state first
        const validation = this.validateState();
        if (!validation.isValid) {
            console.log('State validation failed, not rendering sizes');
            return;
        }

        console.log('Size Render State:', {
            currentProduct: validation.currentProduct.title,
            activeColor: validation.activeColor,
            selectedSize: this.state.selectedSize,
            isFirstClick: this.state.isFirstProductClick,
            isInitialLoad: this.state.isInitialLoad,
            availableVariants: validation.variants.map(v => ({
                size: v.option2,
                available: v.available
            }))
        });

        const sizeContainer = document.createElement('div');
        sizeContainer.className = 'size-selector';
        sizeContainer.setAttribute('data-option-index', '1');
    
        // Add size label (but hidden)
        const sizeLabel = document.createElement('div');
        sizeLabel.className = 'size-label';
        sizeLabel.style.display = 'none';  // Hide the label
        sizeLabel.innerHTML = `
            <div class="col-12 text-left text-lg-center" id="size-name-container" style="font-size: 14px;">
                <b>Size:</b> <span id="selected-size-name">Please select size</span>
            </div>
        `;
        sizeContainer.appendChild(sizeLabel);
    
        // Create container for size elements
        const sizesContainer = document.createElement('div');
        sizesContainer.className = 'size-container';
        sizeContainer.appendChild(sizesContainer);
    
        // Get all possible sizes for this product
        const sizes = [...new Set(validation.variants.map(v => v.option2))];
        
        // Create size elements with accurate availability
        sizes.forEach(size => {
            const variant = validation.variants.find(v => v.option2 === size);
            const isAvailable = variant?.available || false;
            
            const sizeElement = document.createElement('div');
            sizeElement.className = `selector-element size`;
            sizeElement.classList.add(isAvailable ? 'available' : 'soldout');
            sizeElement.setAttribute('data-value', size);
            
            const isSelected = size === this.state.selectedSize;
            
            sizeElement.innerHTML = `
                <input id="swatch-1-${size}" 
                       type="radio" 
                       name="option-1" 
                       value="${size}"
                       ${isSelected ? 'checked' : ''}>
                <label for="swatch-1-${size}">
                    ${size}
                    <div class="crossed-out"></div>
                </label>
            `;
            
            sizesContainer.appendChild(sizeElement);
            
            sizeElement.querySelector('input').addEventListener('change', (e) => {
                this.handleSizeSelection(size);
                document.getElementById('selected-size-name').textContent = size;
            });
        });
    
        // Update the DOM
        if (this.elements.sizeSelectorContainer) {
            this.elements.sizeSelectorContainer.innerHTML = '';
            this.elements.sizeSelectorContainer.appendChild(sizeContainer);
        }
    }

    handleSizeSelection(size) {
        this.state.selectedSize = size;
        document.getElementById('selected-size-name').textContent = size;
        this.updateVariant();
        this.updateAddToCartButton();
        this.updatePrice(); 
    }

    updateProductDetails() {
        // Update materials content
        const materialsContent = document.getElementById('materials-content-text');
        if (materialsContent && this.state.currentProduct?.materials) {
            materialsContent.innerHTML = this.state.currentProduct.materials.replace(/\n/g, '<br>');
        }
    
    // Update size chart image
    const sizeChartImage = document.querySelector('.size-chart-image');
    if (sizeChartImage) {
        if (this.state.currentProduct?.size_chart) {
            // Get the optimized version for display
            const optimizedSrc = this.state.currentProduct.size_chart.replace(/\.(jpg|jpeg|png|gif)/, '_800x.$1');
            sizeChartImage.src = optimizedSrc;
            
            // Store full resolution version for zoom
            sizeChartImage.dataset.zoomSrc = this.state.currentProduct.size_chart;
            
            sizeChartImage.style.display = 'block';
            sizeChartImage.parentElement.style.display = 'block';
        } else {
            sizeChartImage.style.display = 'none';
            sizeChartImage.parentElement.style.display = 'none';
        }
    }
}
        updateVariant() {
        if (!this.state.selectedColor || !this.state.selectedSize) {
            this.state.currentVariant = null;
            return;
        }


        this.state.currentVariant = this.state.currentProduct.variants.find(v => 
            v.option1 === this.state.selectedColor && 
            v.option2 === this.state.selectedSize
        );
    }


    updateAddToCartButton() {
        const button = this.elements.addToCartButton;
        if (!button) return;

        // Extract color from metaobjects using color handle
        let backgroundColor = null;
        if (this.state.selectedColor && window.colorPatterns) {
            // Convert color name to handle (lowercase, spaces to hyphens)
            const colorHandle = this.state.selectedColor.toLowerCase().replace(/\s+/g, '-');
            // Try exact match first
            backgroundColor = window.colorPatterns[colorHandle];
            // If not found, try splitting on hyphens and matching first part (for variations like "crimson-dark" -> "crimson")
            if (!backgroundColor && colorHandle.includes('-')) {
                const baseColor = colorHandle.split('-')[0];
                backgroundColor = window.colorPatterns[baseColor];
            }
        }
        
        // Fallback: try to get from DOM if metaobject lookup failed
        if (!backgroundColor && this.state.selectedColor) {
            const selectedSwatch = document.querySelector(`.swatch-element[data-value="${this.state.selectedColor}"]`);
            if (selectedSwatch) {
                const label = selectedSwatch.querySelector('label');
                if (label) {
                    const inlineStyle = label.getAttribute('style');
                    if (inlineStyle && inlineStyle.includes('background-color')) {
                        const match = inlineStyle.match(/background-color:\s*([^;]+)/);
                        if (match) {
                            backgroundColor = match[1].trim();
                        }
                    }
                }
            }
        }

        const addToCartText = button.querySelector('.add-to-cart-text');
        const soldOutText = button.querySelector('.sold-out-text');
        const priceInfo = button.querySelector('.button-price-info');
        const stockInfo = button.querySelector('.button-stock-info');

        if (!this.state.selectedColor) {
            if (addToCartText) addToCartText.textContent = 'Select Color';
            if (addToCartText) addToCartText.style.display = 'inline-block';
            if (soldOutText) soldOutText.style.display = 'none';
            if (priceInfo) priceInfo.style.display = 'none';
            if (stockInfo) stockInfo.style.display = 'none';
            button.disabled = true;
            button.style.fontWeight = '700';
            button.style.backgroundColor = '#000000';
            button.style.color = '#ffffff';
            return;
        }

        if (!this.state.selectedSize) {
            if (addToCartText) addToCartText.textContent = 'Select Size';
            if (addToCartText) addToCartText.style.display = 'inline-block';
            if (soldOutText) soldOutText.style.display = 'none';
            if (priceInfo) priceInfo.style.display = 'none';
            if (stockInfo) stockInfo.style.display = 'none';
            button.disabled = true;
            button.style.fontWeight = '700';
            // Apply color if available, otherwise default black
            button.style.backgroundColor = backgroundColor || '#000000';
            // Set text color based on background
            this.setButtonTextColor(button, backgroundColor || '#000000');
            return;
        }

        if (!this.state.currentVariant?.available) {
            if (addToCartText) addToCartText.style.display = 'none';
            if (soldOutText) soldOutText.style.display = 'inline-block';
            if (priceInfo) priceInfo.style.display = 'none';
            if (stockInfo) stockInfo.style.display = 'none';
            button.disabled = true;
            button.style.fontWeight = '700';
            button.style.backgroundColor = '#808080';  // Grey for sold out state
            button.style.color = '#ffffff';
            return;
        }

        // Update button with pricing and stock info
        if (addToCartText && this.state.currentVariant) {
            const price = (this.state.currentVariant.price / 100).toFixed(2);
            const comparePrice = this.state.currentVariant.compare_at_price ? (this.state.currentVariant.compare_at_price / 100).toFixed(2) : null;
            
            // Build the text with pricing inline
            let buttonText = 'Add to Cart';
            if (comparePrice && parseFloat(comparePrice) > parseFloat(price)) {
                buttonText += ` - <span class="button-compare-price">$${comparePrice}</span> <span class="button-current-price">$${price}</span>`;
            } else {
                buttonText += ` - <span class="button-current-price">$${price}</span>`;
            }
            
            addToCartText.innerHTML = buttonText;
            addToCartText.style.display = 'block';
        } else if (addToCartText) {
            addToCartText.textContent = 'Add to Cart';
            addToCartText.style.display = 'block';
        }
        if (soldOutText) soldOutText.style.display = 'none';
        if (priceInfo) priceInfo.style.display = 'none';
        
        // Show stock info
        if (stockInfo && this.state.currentVariant?.available) {
            stockInfo.style.display = 'block';
        } else if (stockInfo) {
            stockInfo.style.display = 'none';
        }
        
        button.disabled = false;
        button.style.fontWeight = '700';
        // Apply selected color or default to black
        button.style.backgroundColor = backgroundColor || '#000000';
        // Set text color based on background
        this.setButtonTextColor(button, backgroundColor || '#000000');
    }
    
    setButtonTextColor(button, backgroundColor) {
        if (!backgroundColor) {
            button.style.color = '#ffffff';
            return;
        }
        
        // Create temporary element to convert any color format to RGB
        const tempDiv = document.createElement('div');
        tempDiv.style.backgroundColor = backgroundColor;
        tempDiv.style.position = 'absolute';
        tempDiv.style.visibility = 'hidden';
        document.body.appendChild(tempDiv);
        const computedColor = window.getComputedStyle(tempDiv).backgroundColor;
        document.body.removeChild(tempDiv);
        
        // Extract RGB values
        const rgbMatch = computedColor.match(/\d+/g);
        if (rgbMatch && rgbMatch.length >= 3) {
            const r = parseInt(rgbMatch[0]);
            const g = parseInt(rgbMatch[1]);
            const b = parseInt(rgbMatch[2]);
            // Calculate relative luminance
            const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
            // Use white text for dark backgrounds, black for light backgrounds
            button.style.color = luminance < 0.5 ? '#ffffff' : '#000000';
        } else {
            button.style.color = '#ffffff';
        }
    }

    async handleAddToCart(e) {
        e.preventDefault();
        if (!this.state.currentVariant) return;
    
        try {
            // First add to cart
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [{
                        id: this.state.currentVariant.id,
                        quantity: 1
                    }]
                })
            });
    
            if (!response.ok) throw new Error('Add to cart failed');
    
            // Get updated cart count
            const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
            const cartData = await cartResponse.json();
            
            // Update cart count
            if ($('#cart-count').length > 0) {
                $('#cart-count').html(cartData.item_count);
            } else {
                $('#cart-icon').after('<span id="cart-count">' + cartData.item_count + '</span>');
            }
    
            // Update cart drawer content
            const drawerResponse = await fetch('?section_id=cart-drawer');
            const html = await drawerResponse.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newCartContent = doc.querySelector('.cart-container');
            
            if (newCartContent) {
                const cartDrawer = document.getElementById('cart-drawer');
                const currentContainer = cartDrawer.querySelector('.cart-container');
                if (currentContainer) {
                    currentContainer.innerHTML = newCartContent.innerHTML;
                }
                toggleCart();
            }
    
        } catch (error) {
            console.error('Error adding to cart:', error);
        }
    }
}

// Initialize on DOM load - ensure only one instance
document.addEventListener('DOMContentLoaded', () => {
    // Destroy existing handler if it exists
    if (window.landingPageHandler && window.landingPageHandler.lightbox) {
        try {
            window.landingPageHandler.lightbox.destroy();
        } catch (e) {
            console.warn('Error destroying existing lightbox:', e);
        }
    }
    window.landingPageHandler = new LandingPageHandler();
});